import { useEffect, useState } from 'react'
import { isExtendedDisplay } from './window-management'

/** How often it looks again, besides when the browser says so. */
export const EXTENDED_LOOK_MS = 1000

/**
 * Whether the screens are extended - there is a second screen the
 * presentation can go to - kept current while `watching`. The trainer
 * switches the TV over with the guide open, and the window keeps the focus
 * meanwhile: Chrome says so (`change` on `window.screen`), and it looks again
 * every `EXTENDED_LOOK_MS` besides.
 */
export const useExtendedDisplay = (watching: boolean): boolean | undefined => {
	const [extended, setExtended] = useState(isExtendedDisplay)

	useEffect(() => {
		if (!watching) {
			return
		}
		const look = (): void => setExtended(isExtendedDisplay())
		look()
		window.screen.addEventListener?.('change', look)
		const looking = window.setInterval(look, EXTENDED_LOOK_MS)
		return () => {
			window.screen.removeEventListener?.('change', look)
			window.clearInterval(looking)
		}
	}, [watching])

	return extended
}
